import { apiClient } from './client';
import type { PoruchenieTemplateDto, PoruchenieTemplateInput } from '@expeditor/shared';

/** Админ: конфигурация печатной формы «Поручение экспедитору». */
export const poruchenieTemplateApi = {
  async get(): Promise<PoruchenieTemplateDto> {
    const { data } = await apiClient.get<PoruchenieTemplateDto>('/admin/poruchenie-template');
    return data;
  },
  async save(dto: PoruchenieTemplateInput): Promise<PoruchenieTemplateDto> {
    const { data } = await apiClient.put<PoruchenieTemplateDto>('/admin/poruchenie-template', dto);
    return data;
  },
  /** Предпросмотр бланка (HTML) по текущей раскладке на примерных данных. */
  async preview(dto: PoruchenieTemplateInput): Promise<{ html: string }> {
    const { data } = await apiClient.post<{ html: string }>(
      '/admin/poruchenie-template/preview',
      dto,
    );
    return data;
  },
};
